import React from 'react'
import { images } from '../../../assets'
import { Link } from 'react-router-dom'

function ComejoinCard({data,className}) {
    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      };
    
  return (
    <div className={className.comejoin}>
        <div className={className.comejoincomp}>
            <img src={data.img}  alt='comejoin-bg' />

            <div className={className.comejoincard}>
                <div className={className.comejoincontent}>
                    <div className={className.comejoinheading}>
                    {data.heading}
                    </div>
                    <div className={className.comejoindesc}>
                    {data.desc}
                    </div>

                </div>
                <button className={className.comejoinbutton}>
                    <Link to='/contact' className={className.seeoppurtunities} onClick={scrollToTop} >{data.button}<img src={images.arrowRight} alt='rightArrow' /></Link>
                </button>
            </div>
        </div>
    </div>
  )
}

export default ComejoinCard
